const Addresses = require("./Whitelist.json");
const { MerkleTree } = require("merkletreejs");
const keccak256 = require("keccak256");

const leafNodes = Addresses.map((addr) => keccak256(addr));
const merkleTree = new MerkleTree(leafNodes, keccak256, { sortPairs: true });

module.exports = merkleTree;
